import React from 'react'
import { Snackbar, Grid, Typography } from '@material-ui/core/'
import MuiAlert from '@material-ui/lab/Alert'
import checkNotIcon from '../../../assetss/img/checkNotIcon.svg'
import './index.scss'

const Alert = props => <MuiAlert elevation={6} variant='filled' {...props} />

const AlertCustom = ({ text, deleteText }) => (
  <Grid className='alertWrapper' container justify='space-between' direction='column' alignItems='center'>
    {deleteText ? (
      <Typography className='textNotificationsDelete' align='center'>{text}</Typography>
    ) : (
      <Typography className='textNotifications' align='center'>{text}</Typography>
    )}
    <img className='checkNotIcon' src={checkNotIcon} alt='checkNotIcon' />
  </Grid>
)

const Notification = ({ type, text, open, onClose, deleteText }) => {
  const handleClose = () => onClose(false)

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
    >
      {type === 'error' ? (
        <Alert onClose={handleClose} severity={type}>{text}</Alert>
      ) : (
        <AlertCustom deleteText={deleteText} text={text} />
      )}
    </Snackbar>
  )
}

export default Notification
